// extracted by mini-css-extract-plugin
export default {"tagButton":"tagButton_tagButton__vLwpR","disabled":"tagButton_disabled__f69I9"};